import { EnvironmentInterface } from "./environment.interface";

export const environment: EnvironmentInterface = {
  isProduction: false,
  baseUrl: "https://recruit.dev.werfy.io",
  apiBaseUrl: "https://api.dev.werfy.io",
  linkedInRedirectUrl: "https://www.linkedin.com/oauth/v2/authorization",
  linkedInClientId: "78gqiqyp58t2ol"
};
